<script lang="ts" setup>
	type props = {
		rowCount?: number
		title?: string
		ui?: {
			title?: {
				size?: string
				font?: string
			}
		}
	}

	const configCls = {
		title: {
			size: 'text-2xl sm:text-xl text-base',
			font: 'maitree-semibold'
		}
	}

	withDefaults(defineProps<props>(), {
		rowCount: 2,
		title: "We've transformed insurance for these businesses and more!"
	})
	const imageList = ref<Array<string[]>>([])
	onMounted(async () => {
		const partnersAsset1 = import.meta.glob('/public/img/partners/section-1/*.{png,jpg,jpeg,svg}')
		const partnersAssets2 = import.meta.glob('/public/img/partners/section-2/*.{png,jpg,jpeg,svg}')
		const Asset1 = await Promise.all(
			Object.keys(partnersAsset1).map(async path => {
				const img = (await partnersAsset1[path]()) as { default: any }
				return img.default
			})
		)
		const Asset2 = await Promise.all(
			Object.keys(partnersAssets2).map(async path => {
				const img = (await partnersAssets2[path]()) as { default: any }
				return img.default
			})
		)
		imageList.value = [Asset1, Asset2]
	})

	const cleanAltText = (path: string) => {
		const filename = path.split('/').pop()?.split('.')[0] || 'Partner'
		return filename.replace(/[-_]/g, ' ') + ' Logo'
	}
</script>
<template>
	<section class="flex flex-col md:items-center gap-y-10 sm:gap-y-16">
		<strong
			class="text-blue-950 text-center dark:text-gray-400"
			:class="[ui?.title?.size ?? configCls.title.size, ui?.title?.font ?? configCls.title.font]"
		>
			{{ title }}
		</strong>
		<div class="overflow-hidden sm:space-y-10 space-y-5">
			<div
				v-for="(imageCollection, index) in imageList"
				:key="index"
				class="flex w-full items-center moveX gap-x-5 animation-20s animation-pause-onhover"
				:class="[index === 1 ? 'scroll-inverse' : 'scroll-alternate']"
			>
				<template v-for="i in 2" :key="'effect-' + i">
					<img
						v-for="(item, idx) in imageCollection"
						:key="idx"
						:alt="cleanAltText(item)"
						:src="item"
						loading="lazy"
						class="object-cover flex-none md:max-h-[74px] max-h-[45.85px]"
					/>
				</template>
			</div>
		</div>
	</section>
</template>
